import React from 'react';
import Icon from './Icon';
import './ConfirmDeleteModal.css';

export default function ConfirmDeleteModal({ nomBatch, onConfirm, onAnnuler, loading }) {
  return (
    <div className="cdm-overlay" onClick={onAnnuler}>
      <div className="cdm-modal" onClick={e => e.stopPropagation()}>
        <h3 className="cdm-titre">
          Supprimer le batch <span className="gold">{nomBatch}</span>&nbsp;?
        </h3>

        <p className="cdm-intro">Tout sera définitivement effacé :</p>
        <ul className="cdm-liste">
          <li>
            <Icon name="erreur" size={14} color="var(--danger)" />
            Données de production
          </li>
          <li>
            <Icon name="erreur" size={14} color="var(--danger)" />
            Inventaire
          </li>
          <li>
            <Icon name="erreur" size={14} color="var(--danger)" />
            Écritures comptables
          </li>
        </ul>

        <p className="cdm-wc">
          Les produits sur WooCommerce ne seront pas affectés.
        </p>

        <p className="cdm-avertissement">Cette action est irréversible.</p>

        <div className="cdm-actions">
          <button className="btn btn-ghost" onClick={onAnnuler} disabled={loading}>
            Annuler
          </button>
          <button className="btn btn-danger" onClick={onConfirm} disabled={loading}>
            {loading ? 'Suppression...' : 'Supprimer définitivement'}
          </button>
        </div>
      </div>
    </div>
  );
}
